import { generatePath } from "react-router";

type ParamsType<T> = T extends undefined ? void : T;
export function declareRoute<T = undefined>(path: string) {
    return {
        path,
        link: (params: ParamsType<T>) => generatePath(path, params ?? undefined),
    };
}
